// ============================================================================
// elbiralandokView.js — az "Elbírálandó javaslatok" lapja (2026-10-19, v113). Lásd elbiralandok.js.
// ============================================================================

import { t } from "./i18n.js";
import { el } from "./dom.js";
import { getRoomDisplayName } from "./roomName.js";
import { elbiralandoSorok, sorTemaCim } from "./elbiralandok.js";


/**
 * @param {HTMLElement} app
 * @param {object} model { uiLang, contentLang, rooms, myUid, staff, elbiralandok: { betolt, hiba, adat } }
 * @param {object} handlers { onClose, onOpenMessage(roomId, topicId, messageId) }
 */
export function renderElbiralandok(app, model, handlers) {
  const { uiLang, contentLang } = model;
  const allapot = model.elbiralandok || { betolt: false, hiba: null, adat: null };
  const backdrop = el("div", { class: "sheet-backdrop open" });
  const sheet = el("div", { class: "sheet tall worklist-sheet", role: "dialog", "aria-label": t(uiLang, "suggest.title") });
  sheet.appendChild(el("div", { class: "sheet-handle" }));
  sheet.appendChild(el("h2", { text: "✎ " + t(uiLang, "suggest.title") }));
  backdrop.addEventListener("click", (e) => { if (e.target === backdrop) handlers.onClose(); });
  backdrop.appendChild(sheet);
  app.appendChild(backdrop);

  sheet.appendChild(el("p", { class: "hint", text: t(uiLang, "suggest.intro") }));
  if (allapot.hiba) sheet.appendChild(el("div", { class: "panel-status err", role: "alert", text: allapot.hiba }));
  if (!allapot.adat) {
    sheet.appendChild(el("p", { class: "hint", text: t(uiLang, allapot.betolt ? "suggest.loading" : "suggest.empty") }));
  } else {
    const szobak = model.rooms || [];
    const sorok = elbiralandoSorok(szobak, allapot.adat, model.myUid, model.staff === true);
    // Egy szobából legfeljebb 50 hozzászólás kérdezhető le: ha valamelyik szoba elérte, a lista nem biztos, hogy teljes.
    if (Object.values(allapot.adat).some((a) => a && a.tele === true)) sheet.appendChild(el("p", { class: "hint", text: t(uiLang, "suggest.moreNote") }));
    if (sorok.length === 0) {
      sheet.appendChild(el("p", { class: "hint", text: t(uiLang, "suggest.empty") }));
    } else {
      const lista = el("div", { class: "worklist" });
      for (const sor of sorok) {
        const szoba = szobak.find((r) => r.roomId === sor.roomId);
        const szobaNev = szoba ? getRoomDisplayName(szoba, contentLang, uiLang) : "";
        const tema = sorTemaCim(sor, contentLang);
        const nyelvek = sor.nyelvek.map((n) => (n.n > 1 ? `${n.lang.toUpperCase()} ×${n.n}` : n.lang.toUpperCase())).join(", ");
        lista.appendChild(el("button", {
          type: "button", class: "worklist-row", onclick: () => handlers.onOpenMessage(sor.roomId, sor.topicId, sor.messageId),
        }, [
          el("span", { class: "worklist-room", text: [szobaNev, tema].filter(Boolean).join(" › ") }),
          el("span", { class: "worklist-title", text: sor.szoveg || "…" }),
          el("span", { class: "worklist-meta" }, [
            el("span", { class: "wf-badge wf-review", text: t(uiLang, "suggest.rowCount", { n: sor.osszes, langs: nyelvek }) }),
            sor.sajatJavaslatIs ? el("span", { class: "wf-owner", text: t(uiLang, "suggest.ownToo") }) : null,
          ]),
        ]));
      }
      sheet.appendChild(lista);
    }
  }
  sheet.appendChild(el("button", { type: "button", class: "text-btn sheet-close", text: t(uiLang, "admin.close"), onclick: handlers.onClose }));
}
